// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e08e5c2b","455":"ab681408","977":"db0038ff"}[chunkId] + ".chunk.js";
};